module.exports = __webpack_public_path__ + "static/parade-2020-house54-ab608a41aedfb3329d293bac0d8b43e3.jpg";